import { Button } from 'reactstrap/lib';

type Props = {
  onClick: () => void;
};

export default function SubmitButton({ onClick }: Props) {
  return (
    <Button color='primary' onClick={onClick}>
      <span>Submit</span>
      <i className='fas fa-arrow-right ml-3' />
    </Button>
  );
}
